/** E9-45 length limits for a first-touch email; Go enforces both. The subject is measured once its merge fields are filled in. */
export const BODY_MAX = 2000;
export const BODY_WARN = 1200;
export const SUBJECT_WARN = 45;
export const SUBJECT_MAX = 60;
export const BODY_LIMIT = { warnAbove: BODY_WARN, max: BODY_MAX } as const;
export const SUBJECT_LIMIT = { warnAbove: SUBJECT_WARN, max: SUBJECT_MAX } as const;

export type CapLevel = 'ok' | 'warn' | 'over';

/** Characters as a person counts them: an emoji is one, not two UTF-16 units (Go counts characters too). */
export function countChars(text: string): number {
  return Array.from(text).length;
}

export function capLevel(length: number, warnAbove: number, max: number): CapLevel {
  if (length > max) return 'over';
  return length > warnAbove ? 'warn' : 'ok';
}

export const BODY_OVER_COPY = `This email is over the ${BODY_MAX.toLocaleString('en-US')}-character limit. Shorten it to save.`;

export function bodyOverCap(body: string): boolean {
  return countChars(body) > BODY_MAX;
}

export const SUBJECT_OVER_COPY = `This subject is over the ${SUBJECT_MAX}-character limit. Shorten it to save.`;

export function subjectOverCap(subject: string): boolean {
  return countChars(subject.trim()) > SUBJECT_MAX;
}

/** A template's subject goes up untrimmed and Go counts it as sent, so the editor counts it raw too. */
export function templateSubjectOverCap(subject: string): boolean {
  return countChars(subject) > SUBJECT_MAX;
}
